//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { ReportType } from './Enums';

export class SalesTaxReportInputItem extends ReportInputItem implements IReportDateRangeInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    IncludePreviousBalance: boolean = false;
    override readonly Type: ReportType = ReportType.SalesTax;

    constructor(initializer?: Partial<Omit<SalesTaxReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "SalesTaxReportInputItem";
}
